import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { ComponentConfig } from "@measured/puck"
import { CustomizeTourProps, RenderConfig } from "./RenderConfig"

export const CaoCaoCustomizeTour: ComponentConfig<CustomizeTourProps> = {
  label: "CaoCao | Customize Tour",
  //@ts-ignore
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    description: {
      label: "Description",
      type: "textarea",
    },
    buttonText: {
      label: "Button Text",
      type: "text",
    },
    buttonLink: {
      label: "Button Link",
      type: "text",
    },
    tourTypes: {
      label: "Tour Types",
      type: "array",
      arrayFields: {
        title: {
          label: "Tour Title",
          type: "text",
        },
        imageUrl: {
          label: "Tour Image",
          type: "custom",
          render: props => <MediaSelect {...props} mediaType="image" />,
        },
        link: {
          label: "Tour Link",
          type: "text",
        },
      },
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    title: "Customize Tour",
    description:
      "By listening to our customers and crafting diverse, exciting, and safe tours, Cao Cao Adventures can become the go-to choice for your unforgettable cycling experiences in Vietnam.",
    buttonText: "Design your Itinerary",
    buttonLink: "#",
    tourTypes: [
      {
        title: "Corporate",
        imageUrl: "",
        link: "#",
      },
      {
        title: "Private",
        imageUrl: "",
        link: "#",
      },
      {
        title: "Club",
        imageUrl: "",
        link: "#",
      },
      {
        title: "Charity",
        imageUrl: "",
        link: "#",
      },
      {
        title: "School",
        imageUrl: "",
        link: "#",
      },
    ],
    className: "",
  },
  ...RenderConfig,
}
